<template>
  <div>
    <page-header :title="$t('system.pre_defined_tags')" />
    <page-body>
     <list :id="listId" />
   </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'PreDefinedTagIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'PreDefinedTagList',
    }
  },
}
</script>
